/* eslint-disable no-self-assign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import style from './CampaignList.module.css';
import { Table, Input, Pagination, Space, Dropdown, Checkbox, Tag, Spin, message } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CiMenuKebab, CiSearch } from 'react-icons/ci';
import Button from '../../components/Basic/button';
import FormModal from '../../components/Modal/CampaignModal';
// import Features from '../Features/Features'
import * as Actions from '../../store/slices/getAllCampaign';
import * as CreateActions from '../../store/slices/createCampaign'
import Form from '../../Forms/PersonalInfoForm'
import { connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';
import Header from '../../components/Header/header';
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
import { useNavigate } from 'react-router-dom';
import CampaignViewModal from '../../components/Modal/CampaignViewModal';


interface DataSource {
    key: string;
    CampaignName: string;
    createdAt: string;
    StartTime: string;
    EndTime: string;
    campaignStatus: string;
    campaignId: number;
    noOfWinners: number;
    prizeGift: string;
}

interface getData {
    getAllCampaign: () => void,
    getCampaign_Red: any;
    createCampaign_Red: any;
    updateCampaignStatus: (campaignId: string, status: string) => void;
    cancelCampaign: (campaignId: string) => void;
    createCampaign: (campaignData: any) => Promise<any>;
    getByID: (campaignId: string) => Promise<any>;
    updateCampaign: (campaignData: any) => Promise<any>;
    getField: () => Promise<any>;
    getUnapprovedFiles: () => Promise<any>;
}

const MultiViewTable: React.FC<getData> = ({ getAllCampaign, getCampaign_Red, updateCampaignStatus, cancelCampaign, createCampaign_Red, createCampaign, getByID, updateCampaign, getField, getUnapprovedFiles }) => {

    const navigate = useNavigate();
    const [spinning, setSpinning] = useState(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(9);
    const [searchText, setSearchText] = useState<string>('');
    const [selectedColumns, setSelectedColumns] = useState<string[]>(['CampaignName', 'campaignId', 'createdAt', 'StartTime', 'EndTime', 'campaignStatus', 'noOfWinners',]);
    const [loadingText, setLoadingText] = useState<boolean>(true)
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [openCancel, setOpenCancel] = useState(false);
    const [showForm, setShowForm] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string>('')
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [Data, setData] = useState(getCampaign_Red?.data[0]?.res?.data)
    const [currentCampaignId, setCurrentCampaignId] = useState<string | null>(null);
    const [currentRowKey, setCurrentRowKey] = useState<string | null>(null);
    const [currentStatusToSet, setCurrentStatusToSet] = useState<'approve' | 'reject' | null>(null);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [viewCampaignId, setViewCampaignId] = useState<string | null>(null);
    const [dataSource, setDataSource] = useState<DataSource[]>([
        {
            key: Data?.[0]?.campaignId || 'N/A',
            CampaignName: Data?.[0]?.campaignName || 'N/A',
            createdAt: Data?.[0]?.createdAt || 'N/A',
            StartTime: Data?.[0]?.startDate || 'N/A',
            EndTime: Data?.[0]?.endDate || 'N/A',
            campaignStatus: Data?.[0]?.campaignStatus || 'N/A',
            noOfWinners: Data?.[0]?.noOfWinners || 0,
            prizeGift: Data?.[0]?.campaignWinners?.[0]?.prizeGift || 'N/A',
            campaignId: Data?.[0]?.campaignId || 'N/A',
        },
    ]);
    useEffect(() => {
        if (getCampaign_Red?.data?.[0]?.res?.data) {
            const fetchedData = getCampaign_Red.data[0].res.data;
            setData(fetchedData);
            setDataSource(
                fetchedData.map((item: any, index: number) => ({
                    key: item.campaignId,
                    campaignId: item.campaignId,
                    CampaignName: item.campaignName || 'N/A',
                    createdAt: item.createdAt.replace("T", "   ").split('.')[0] || 'N/A',
                    StartTime: item.startDate || 'N/A',
                    EndTime: item.endDate || 'N/A',
                    campaignStatus: item.campaignStatus || 'N/A',
                    noOfWinners: item.noOfWinners || 'N/A',
                    prizeGift: item.campaignWinners?.[0]?.prizeGift || 'N/A',
                }))
            );
        } else if (getCampaign_Red?.dataSingle?.[0]?.res?.status === '1004') {
            message.error(getCampaign_Red.dataSingle[0].res.message);
            localStorage.clear();
            navigate('/');
        } else if (getCampaign_Red?.dataSingle?.[0]?.res?.status === '1005') {
            message.warning(getCampaign_Red.dataSingle[0].res.message);
            setData([]);
            setDataSource([]);
        } else if (getCampaign_Red?.dataSingle?.length > 0) {
            console.error('API Error:', getCampaign_Red.dataSingle);
            setData([]);
            setDataSource([]);
        } else {
            setData([]);
            setDataSource([]);
        }
    }, [getCampaign_Red]);


    const onSearch = (value: string) => setSearchText(value.toLowerCase());

    const handleCheckboxChange = (checked: boolean, column: string) => {
        setSelectedColumns((prevSelected) =>
            checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
        );
    };

    useEffect(() => {
        getAllCampaign();
    }, []);



    const Addhandle = () => {
        setShowForm(true);
    };
    const Eidthandle = (key: string) => {
        setCurrentCampaignId(key);
        setShowForm(true);
    };

    const Backhandle = () => {
        setShowForm(false)
        setSpinning(true);
        getAllCampaign();
        setTimeout(() => {
            setSpinning(false);
        }, 2000);
        setCurrentCampaignId('');
    };

    const HandleApprove = (key: string) => {
        setModalText('Approve Campaign');
        setCurrentRowKey(key);
        setCurrentStatusToSet('approve');   // ← naya state
        setOpen(true);
    };

    const HandleReject = (key: string) => {
        setModalText('Reject Campaign');
        setCurrentRowKey(key);
        setCurrentStatusToSet('reject');    // ← naya state
        setOpen(true);
    };

    const HandleCancel = (key: string) => {
        setModalText('Are you sure to cancel campaign');
        setCurrentRowKey(key);
        setOpenCancel(true);
    };

    const HandleView = (key: string) => {
        setViewCampaignId(key);
        setViewModalOpen(true);
    };

    const handleViewApprove = async (id: string) => {
        const result: any = await updateCampaignStatus(id, 'approve');
        if (result?.success) {
            message.success(result?.message || 'Campaign approved successfully');
        } else {
            message.error(result?.message || 'Operation failed');
        }
        getAllCampaign();
    };

    const handleViewReject = async (id: string) => {
        const result: any = await updateCampaignStatus(id, 'reject');
        if (result?.success) {
            message.success(result?.message || 'Campaign rejected successfully');
        } else {
            message.error(result?.message || 'Operation failed');
        }
        getAllCampaign();
    };

    const actionMenu = (key: string, status: string) => (
        <Space direction="vertical" className={style.actions}>
            {hasPermission(PERMISSIONS.CAMPAIGN_VIEW) && (
                <div className={style.dropdownItem} onClick={() => HandleView(key)}>View</div>
            )}
            {hasPermission(PERMISSIONS.CAMPAIGN_UPDATE) && status !== 'COMPLETED' && status !== 'EXECUTED' && (
                <div className={style.dropdownItem} onClick={() => Eidthandle(key)}>Edit</div>
            )}
            {status === 'PENDING' && (
                <>
                    {hasPermission(PERMISSIONS.CAMPAIGN_APPROVE) && (
                        <div className={style.dropdownItem} onClick={() => HandleApprove(key)}>Approve</div>
                    )}
                    {hasPermission(PERMISSIONS.CAMPAIGN_REJECT) && (
                        <div className={style.dropdownItem} onClick={() => HandleReject(key)}>Reject</div>
                    )}
                </>
            )}
            {status === 'APPROVED' && hasPermission(PERMISSIONS.CAMPAIGN_CANCEL) && (
                <div className={style.dropdownItem} onClick={() => HandleCancel(key)}>Cancel</div>
            )}
        </Space>
    );

    const allColumns = [
        {
            title: 'Campaign Id',
            dataIndex: 'campaignId',
            key: 'campaignId',
            width: 50,
            // sorter: (a: DataSource, b: DataSource) => Number(a.campaignId) - Number(b.campaignId),
        },
        {
            title: 'Campaign Name',
            dataIndex: 'CampaignName',
            key: 'CampaignName',
            width: 150,
            // sorter: (a: DataSource, b: DataSource) => a.CampaignName.localeCompare(b.CampaignName),

        },

        {
            title: 'Start Time',
            dataIndex: 'StartTime',
            key: 'StartTime',
            width: 120,
            // sorter: (a: DataSource, b: DataSource) => a.StartTime.localeCompare(b.StartTime),
        },
        {
            title: 'End Time',
            dataIndex: 'EndTime',
            key: 'EndTime',
            width: 100,
            // sorter: (a: DataSource, b: DataSource) => a.EndTime.localeCompare(b.EndTime),
        },
        {
            title: 'Campaign Status',
            dataIndex: 'campaignStatus',
            key: 'campaignStatus',
            width: 120,
            // sorter: (a: DataSource, b: DataSource) => a.campaignStatus.localeCompare(b.campaignStatus),
            render: (campaignStatus: string) => {
                const Color = campaignStatus === 'APPROVED' ? 'green' : campaignStatus === 'PENDING' ? 'yellow' : campaignStatus === 'decline' ? "red" : "blue";
                return (
                    <Tag style={{ marginInlineEnd: 0, fontSize: 12, fontWeight: 600 }} color={Color}>
                        {campaignStatus.toUpperCase()}
                    </Tag>
                )
            },
        },
        {
            title: 'Creation Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            // sorter: (a: DataSource, b: DataSource) => a.CampaignName.localeCompare(b.CampaignName),
        },
        {
            title: 'No Of Winners',
            dataIndex: 'noOfWinners',
            key: 'noOfWinners',
            width: 50,
            // sorter: (a: DataSource, b: DataSource) => Number(a.noOfWinners) - Number(b.noOfWinners),
        },
        {
            title: 'Action',
            key: 'action',
            fixed: 'right' as const,
            width: 50,
            render: (_: any, record: DataSource) => (
                <Dropdown
                    overlay={actionMenu(record.key, record.campaignStatus)}
                    trigger={['click']}
                    placement="bottomRight"
                >
                    <CiMenuKebab className={style.actionIcon} />
                </Dropdown>
            ),
        },
    ];

    const filteredColumns = allColumns.filter((col) => selectedColumns.includes(col.key) || col.key === 'action');

    const filteredData = dataSource.filter((item) =>
        item.StartTime.toLowerCase().includes(searchText) ||
        item.CampaignName.toLowerCase().includes(searchText) ||
        item.createdAt.toLowerCase().includes(searchText) ||
        item.EndTime.toLowerCase().includes(searchText) ||
        item.campaignStatus.toLowerCase().includes(searchText) ||
        item.noOfWinners.toFixed().includes(searchText) ||
        item.prizeGift.toLowerCase().includes(searchText)
    );

    const items = [
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('StartTime')}
                    value={'StartTime'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'StartTime')}
                >
                    Start Time
                </Checkbox>
            ),
            key: '1',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('CampaignName')}
                    value={'CampaignName'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'CampaignName')}
                >
                    Campaign Name
                </Checkbox>
            ),
            key: '2',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('EndTime')}
                    value={'EndTime'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'EndTime')}
                >
                    End Time
                </Checkbox>
            ),
            key: '3',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('campaignStatus')}
                    value={'campaignStatus'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'campaignStatus')}
                >
                    Campaign Status
                </Checkbox>
            ),
            key: '4',
        },
        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('noOfWinners')}
                    value={'noOfWinners'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'noOfWinners')}
                >
                    No Of Winners
                </Checkbox>
            ),
            key: '5',
        },

        {
            label: (
                <Checkbox
                    checked={selectedColumns.includes('createdAt')}
                    value={'createdAt'}
                    onChange={(e) => handleCheckboxChange(e.target.checked, 'createdAt')}
                >
                    Creation Date
                </Checkbox>
            ),
            key: '9',
        },
    ];


    useEffect(() => {
        setLoadingText(true)
        setTimeout(() => {
            setLoadingText(false)
        }, 2000)
    }, [])





    // const confirmApproval = async () => {
    //     if (!currentRowKey || !currentStatusToSet) return;
    //     setSpinning(true)
    //     if (currentRowKey) {
    //         setLoadingText(true);
    //         try {
    //             await updateCampaignStatus(currentRowKey, currentStatusToSet);
    //             setCurrentRowKey(null);
    //             setSpinning(false)
    //             getAllCampaign();

    //         } catch (error) {
    //             console.error('Failed to approve campaign:', error);
    //             setSpinning(false)
    //         } finally {
    //             setLoadingText(false);
    //             setOpen(false);

    //         }
    //     }
    // };

    const confirmApproval = async () => {
        if (!currentRowKey || !currentStatusToSet) return;

        setSpinning(true);
        setLoadingText(true);

        try {
            const result: any = await updateCampaignStatus(currentRowKey, currentStatusToSet);
            if (result?.success) {
                message.success(result?.message || `Campaign ${currentStatusToSet === 'approve' ? 'approved' : 'rejected'} successfully`);
            } else {
                message.error(result?.message || 'Operation failed');
            }
            getAllCampaign();
        } catch (error) {
            console.error(`Failed to ${currentStatusToSet} campaign:`, error);
            message.error('An error occurred');
        } finally {
            setSpinning(false);
            setLoadingText(false);
            setOpen(false);
            setCurrentRowKey(null);
            setCurrentStatusToSet(null);
        }
    };

    const Completed = async () => {
        if (currentRowKey) {
            setLoadingText(true);
            try {
                await updateCampaignStatus(currentRowKey, 'completed');
                setDataSource((prevDataSource) =>
                    prevDataSource.map((item) =>
                        item.key === currentRowKey
                            ? { ...item, campaignStatus: 'completed' }
                            : item
                    )
                );
                setCurrentRowKey(null);
            } catch (error) {
                console.error('Failed to approve campaign:', error);
            } finally {
                setLoadingText(false);
                setOpen(false);
            }
        }
    };

    const cancelComplete = async () => {
        if (currentRowKey) {
            setLoadingText(true);
            try {
                await updateCampaignStatus(currentRowKey, 'decline');
                setDataSource((prevDataSource) =>
                    prevDataSource.map((item) =>
                        item.key === currentRowKey
                            ? { ...item, campaignStatus: 'decline' }
                            : item
                    )
                );
                setCurrentRowKey(null);
            } catch (error) {
                console.error('Failed to approve campaign:', error);
            } finally {
                setLoadingText(false);
                setOpen(false);
            }
        }
    };

    const cancelApproval = () => {
        setOpen(false);
        setCurrentRowKey(null);
        setCurrentStatusToSet(null);
    };

    const confirmCancel = async () => {
        if (!currentRowKey) return;
        setSpinning(true);
        setLoadingText(true);
        try {
            const result: any = await cancelCampaign(currentRowKey);
            if (result?.success) {
                message.success(result?.message || 'Campaign cancelled successfully');
            } else {
                message.error(result?.message || 'Failed to cancel campaign');
            }
            getAllCampaign();
        } catch (error) {
            console.error('Failed to cancel campaign:', error);
            message.error('An error occurred');
        } finally {
            setSpinning(false);
            setLoadingText(false);
            setOpenCancel(false);
            setCurrentRowKey(null);
        }
    };

    const cancelCancelModal = () => {
        setOpenCancel(false);
        setCurrentRowKey(null);
    };



    return (
        <>
            <Header />
            <Spin spinning={spinning} fullscreen />
            <FormModal
                modalTitle={modalText}
                Subtitle={''}
                open={open}
                setOpen={setOpen}
                onOk={confirmApproval}
                onCancel={cancelApproval}
                okText={currentStatusToSet === 'approve' ? 'Approve' : 'Reject'}
                cancelText="Cancel"
            />
            <FormModal modalTitle={modalText} Subtitle={''} open={open2} setOpen={setOpen2} onOk={Completed} onCancel={cancelComplete} okText='Completed' cancelText='Decline' />
            <FormModal modalTitle={modalText} Subtitle={''} open={openCancel} setOpen={setOpenCancel} onOk={confirmCancel} onCancel={cancelCancelModal} okText='Cancel Campaign' cancelText='Close' />
            <CampaignViewModal
                open={viewModalOpen}
                campaignId={viewCampaignId}
                onClose={() => setViewModalOpen(false)}
                onApprove={handleViewApprove}
                onReject={handleViewReject}
                getByID={getByID}
                canApprove={hasPermission(PERMISSIONS.CAMPAIGN_APPROVE)}
                canReject={hasPermission(PERMISSIONS.CAMPAIGN_REJECT)}
            />
            {showForm ? (
                // <Features Back={Backhandle} currentCampaignId={currentCampaignId} />
                <Form Back={Backhandle} createCampaign_Red={createCampaign_Red} currentCampaignId={currentCampaignId} getByID={getByID} getField={getField} updateCampaign={updateCampaign} createCampaign={createCampaign} getUnapprovedFiles={getUnapprovedFiles} />
            ) : (
                <>
                    <div className={style.Route}>
                        <h5>Campaign List</h5>

                        {hasPermission(PERMISSIONS.CAMPAIGN_CREATE) && (
                            <div className={style.btns}>
                                <Button
                                    Text={'Create campaign'}
                                    buttonClass={style.createBtn}
                                    onClick={Addhandle}
                                    Disable={loadingText}
                                />
                            </div>
                        )}
                    </div>
                    <div className={style.container}>
                        <Space className={style.SearchTable}>
                            <div className={style.SearchBar}>
                                <Input
                                    placeholder="Search..."
                                    prefix={<CiSearch size={20} />}
                                    // suffix={<CiFilter size={20} className={style.filterIcon} />}
                                    onChange={(e) => onSearch(e.target.value)}
                                    style={{ width: 200 }}
                                    className={style.inputSearch}
                                />
                                <Dropdown
                                    menu={{ items }}
                                    trigger={['click']}
                                >
                                    <SettingOutlined className={style.tableSettings} />
                                </Dropdown>
                            </div>
                        </Space>
                        <Table
                            loading={loadingText}
                            columns={filteredColumns}
                            dataSource={filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
                            pagination={false}
                            rowSelection={{
                                type: 'checkbox',
                                onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
                            }}
                            size="small"
                            onChange={(pagination, filters, sorter) => {
                                if (!Array.isArray(sorter)) {
                                }
                            }}
                        />
                        <Pagination
                            align="end"
                            showTotal={(total) => `Total ${total} items`}
                            current={currentPage}
                            total={filteredData.length}
                            pageSize={pageSize}
                            onChange={(page, newSize) => {
                                setCurrentPage(page);
                                setPageSize(newSize);
                            }}
                            style={{ marginTop: 16 }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

function mapStateToProps(state: any) {
    return {
        getCampaign_Red: state.getCampaign_Red,
        createCampaign_Red: state.createCampaign_Red,
    };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    createCampaign: (campaignData: any) => dispatch(CreateActions.createCampaign(campaignData)),
    getByID: (campaignId: string) => dispatch(CreateActions.getByID(campaignId)),
    getField: () => dispatch(CreateActions.getField()),
    getUnapprovedFiles: () => dispatch(CreateActions.getUnapprovedFiles()),
    updateCampaign: (campaignData: any) => dispatch(CreateActions.updateCampaign(campaignData)),
    updateCampaignStatus: (campaignId: string, status: string) => dispatch(Actions.updateCampaignStatus(campaignId, status = status)),
    cancelCampaign: (campaignId: string) => dispatch(Actions.cancelCampaign(campaignId)),
    getAllCampaign: () => dispatch(Actions.getAllCampaign() as any),
});
export default connect(mapStateToProps, mapDispatchToProps)(MultiViewTable);
